"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadSuccessModal = void 0;
const react_1 = __importDefault(require("react"));
const react_modal_1 = __importDefault(require("react-modal"));
const theme_ui_1 = require("theme-ui");
const user_1 = require("./user");
const UploadSuccessModal = ({ showModal, setShowModal }) => {
    const user = user_1.useUser();
    const gardenUrl = `https://${user === null || user === void 0 ? void 0 : user.getUsername()}.roam.garden`;
    return react_1.default.createElement(react_modal_1.default, { isOpen: showModal, ariaHideApp: false, parentSelector: () => document.getElementById("subscription-modal-parent"), style: {
            overlay: {
                display: "flex",
            },
            content: {
                margin: "auto",
                position: "unset",
            },
        } },
        react_1.default.createElement(theme_ui_1.Flex, null,
            react_1.default.createElement(theme_ui_1.Heading, { as: "h2", sx: {
                    whiteSpace: "pre-line",
                    lineHeight: "2em",
                } },
                "Your garden is growing. It usually takes 10-15min (longer if your garden is large)." +
                    "\nYou'll get an email when it goes live." +
                    "\nIt'll be available at ",
                react_1.default.createElement(theme_ui_1.Link, { href: gardenUrl }, gardenUrl)),
            react_1.default.createElement(theme_ui_1.Close, { sx: { justifySelf: "start" }, onClick: () => setShowModal(false) })));
};
exports.UploadSuccessModal = UploadSuccessModal;
//# sourceMappingURL=upload-success-modal.js.map